import React from 'react';
import { IconArrowRightRegular, IconLowestRegular, NormalButton } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { TouchAccessibilityWrapper } from '@domains/pdp-common';

interface CouponProps {
  buttonColor: string;
  moveToCouponRegisterPage: () => void;
}
export const CreatorCouponRegister: React.FC<React.PropsWithChildren<CouponProps>> = ({
  buttonColor,
  moveToCouponRegisterPage,
}) => {
  return (
    <TouchAccessibilityWrapper onClick={moveToCouponRegisterPage} touchHeight={48}>
      <CreatorCouponRegisterButton variant='tertiary' size='small' color={buttonColor}>
        <span>크리에이터 쿠폰 입력하기</span>
        <IconArrowRightRegular size={16} style={{ color: buttonColor }} />
      </CreatorCouponRegisterButton>
    </TouchAccessibilityWrapper>
  );
};

const CreatorCouponRegisterButton = styled(NormalButton)<{ color: string }>`
  padding: 8px 8px 8px 12px;
  width: 172px;
  height: 32px;
  gap: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  cursor: pointer;
  white-space: nowrap;
  color: ${({ color }) => color};
  border-color: ${({ color }) => color};
  pointer-events: auto;
`;
